import angular from 'angular';
import AdminReportsFilterComponent from './admin-reports-filter-component';

export default angular.module('admin-reports-filter', []).component('adminReportsFilter', new AdminReportsFilterComponent());



// WEBPACK FOOTER //
// ./src/modules/admin-reports/components/admin-reports-filter/admin-reports-filter-module.js